import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
// import AnnouncementBar from './AnnouncementBar'; // Hidden for now
import NewHeader from './NewHeader';
import NewFooter from './NewFooter';
import MobileBottomNav from './MobileBottomNav';
import FloatingChatButton from './FloatingChatButton';
import DiscountPopup from './DiscountPopup';
import { StorefrontI18nProvider } from '../i18n/StorefrontI18nProvider';
import UtmCapture from './UtmCapture';

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${props => props.theme.colors.background.primary};
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
`;

const NewLayout: React.FC = () => {
  return (
    <StorefrontI18nProvider>
      <UtmCapture />
      <LayoutContainer>
        {/* <AnnouncementBar /> */}
        <NewHeader />
        <Main>
          <Outlet />
        </Main>
        <NewFooter />
        <MobileBottomNav />
        <FloatingChatButton />
        <DiscountPopup />
      </LayoutContainer>
    </StorefrontI18nProvider>
  );
};

export default NewLayout;
